import React, { useCallback } from 'react';
import { SettingsItem } from 'design-system';
import { SettingsSection } from 'design-system/SettingsSection';
import * as Icons from 'design-system/icons';
import Links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useOpenSupport from 'features/support/hooks/useOpenSupport';
const HelpItems = ({ showSendFeedback }) => {
    const navigation = useMainStackNavigation();
    const openSupport = useOpenSupport();
    const onPressBrowseAllHelpTopics = useCallback(() => {
        Links.openEmmaHelp();
    }, []);
    const onPressChatWithUs = useCallback(() => {
        openSupport();
    }, [openSupport]);
    const onPressOurLearningMaterial = useCallback(() => {
        navigation.navigateDeprecated('Learn');
    }, []);
    const onPressSendFeedback = useCallback(() => {
        // Fix the link here
        Links.openEmmaCommunity();
    }, []);
    const onPressCommunity = useCallback(() => {
        Links.openEmmaCommunity();
    }, []);
    return (<>
      <SettingsSection name="More options">
        <SettingsItem title={'Browse all help topics'} icon={<Icons.IconDocument gradientKey="skyBlue"/>} onPress={onPressBrowseAllHelpTopics}/>
        <SettingsItem title={'Chat with us'} icon={<Icons.IconMessages gradientKey="apricot"/>} onPress={onPressChatWithUs}/>
      </SettingsSection>
      <SettingsSection name="Others">
        <SettingsItem title={'Our learning material'} icon={<Icons.IconBook alt gradientKey="apricot"/>} onPress={onPressOurLearningMaterial}/>
        {!!showSendFeedback && (<SettingsItem title={'Send feedback'} icon={<Icons.IconMessage gradientKey="darkPink"/>} onPress={onPressSendFeedback}/>)}
        <SettingsItem title={'Community'} icon={<Icons.IconCommunity gradientKey="lightPink"/>} onPress={onPressCommunity}/>
      </SettingsSection>
    </>);
};
export default HelpItems;
